/*
 * @Author: Json Chen
 * @Date: 2021-06-25 13:30:01
 * @LastEditTime: 2021-06-30 17:24:14
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/linkLibrary/index.ts
 */
import { get, post, remove } from 'src/tools/server';

export const getResourceList = (
  startIndex: number,
  pageCount: number,
  body: any,
) => {
  return post<any>(`/portal/linkLibrary/${startIndex}/${pageCount}`, body, {});
};
export const createNewLinkLibrary = (body: any) => {
  return post<any>(`/portal/linkLibrary`, body, {});
};

export const searchMiniOptions = (keyword) => {
  return get<any>(`/portal/linkLibraries/miniProgram/${keyword}`, {});
};

export const getLinkLibraryDetail = (uuid) => {
  return get<any>(`/portal/linkLibrary/${uuid}`, {});
};

export const getLinkedItems = (uuid) => {
  return get<any>(`/portal/linkLibrary/linkedItems/${uuid}`, {});
};

export const linkItemUnLink = (body: any) => {
  return post<any>(`/portal/linkLibrary/linkedItems/unLink`, body, {});
};

export const deleteLinkedLibrary = (uuid) => {
  return remove<any>(`/portal/linkLibrary/${uuid}`, {});
};
